import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { AccessExpired } from "@/components/demo/DemoUi";

const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#FAFAF6]" data-testid="auth-loading">
    <div className="flex flex-col items-center gap-3">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-[#3E7256]" />
      <p className="text-sm text-slate-400">Chargement…</p>
    </div>
  </div>
);

export const ProtectedLayout = () => {
  const { user, logout, reload } = useAuth();
  if (user === undefined) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.approval_status && user.approval_status !== "approved") return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAFAF6] p-6">
      <div className="max-w-lg rounded-xl border bg-white p-8 text-center" data-testid="approval-pending">
        <h1 className="text-2xl font-semibold">{user.approval_status === "rejected" ? "Demande d’accès refusée" : "Inscription en attente de validation"}</h1>
        <p className="my-5 text-slate-600">{user.approval_status === "rejected" ? "Votre demande n’a pas été acceptée par l’administrateur." : "Votre inscription est enregistrée. Un administrateur doit autoriser votre accès à Lodge & Co avant de poursuivre."}</p>
        <button className="m-2 rounded-lg bg-[#1E3D2B] px-4 py-2 text-white" onClick={reload}>Vérifier mon accès</button>
        <button className="m-2 rounded-lg border px-4 py-2" onClick={logout}>Se déconnecter</button>
      </div>
    </div>
  );
  return <Outlet />;
};

export const RequireOrgLayout = () => {
  const { memberships, user, orgAccessLost } = useAuth();
  if (memberships.length === 0) {
    if (user?.is_platform_admin) return <Navigate to="/admin" replace />;
    // A previously-usable org disappeared (e.g. expired Demo membership):
    // show a safe access-expired state instead of leaking to onboarding.
    if (orgAccessLost) return <AccessExpired />;
    return <Navigate to="/onboarding" replace />;
  }
  return <Outlet />;
};

export const RequireOnboardingLayout = () => {
  const { memberships, activeOrgId } = useAuth();
  const active = memberships.find((m) => m.org.id === activeOrgId) || memberships[0];
  if (active && active.org.onboarding_completed === false) {
    return <Navigate to={`/organization-setup?org=${active.org.id}`} replace />;
  }
  return <Outlet />;
};

export const PublicOnly = () => {
  const { user } = useAuth();
  if (user === undefined) return <Loader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};
